import PropTypes from 'prop-types';
import { Box, Divider, List, ListItem, Typography } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

// Riquadro dati bonifico (beneficiario / IBAN / causale / importo) + nota informativa.
// Estratto a comportamento invariato dalla sezione "bonifico" duplicata in RegistrationPage
// e ProfilePage. Presentazionale: riceve valori già formattati; i wrapper Grid e i bottoni
// (copia dati / invia mail / chiudi) restano nel componente padre.
export default function BankTransferInfo({ beneficiary, iban, causale, amount, currency, note }) {
  return (
    <>
      <List sx={{ width: '100%' }}>
        <ListItem>
          <Typography variant="subtitle1" component="div">
            Beneficiario: {beneficiary}
          </Typography>
        </ListItem>
        <Divider sx={{ marginLeft: 2 }} />

        <ListItem>
          <Typography variant="subtitle1" component="div">
            IBAN: {iban}
          </Typography>
        </ListItem>
        <Divider sx={{ marginLeft: 2 }} />

        <ListItem>
          <Typography variant="subtitle1" component="div">
            Causale: {causale}
          </Typography>
        </ListItem>
        <Divider sx={{ marginLeft: 2 }} />

        <ListItem>
          <Typography variant="subtitle1" component="div">
            Importo: {amount} {currency}
          </Typography>
        </ListItem>
        <Divider sx={{ marginLeft: 2 }} />
      </List>

      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '6px', marginTop: '4px' }}>
        <InfoIcon fontSize="10px" />
        <Typography variant="caption" display="block">
          {note}
        </Typography>
      </Box>
    </>
  );
}

BankTransferInfo.propTypes = {
  beneficiary: PropTypes.string,
  iban: PropTypes.string,
  causale: PropTypes.node,
  amount: PropTypes.node,
  currency: PropTypes.string,
  note: PropTypes.node,
};
